module.exports = __webpack_public_path__ + "img/body-1-lg.9da24fab.png";